const { formatMoney, trapFocus, disableTrapFocus } = window.BAO.Utils

class IWishlist extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.observeDrawer()

    this.updateWishlistCount()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
      })
    }

    if (
      document.querySelector('.iWishAdd') ||
      document.querySelector('.iWishAddColl')
    ) {
      document
        .querySelectorAll('.iWishAdd, .iWishAddColl')
        .forEach(addToWishlistEl => {
          addToWishlistEl.addEventListener('click', () => {
            window.setTimeout(() => {
              this.updateWishlistCount()
            }, 500)
          })
        })
    }

    const wishlistTriggers = document.querySelectorAll('.iWishView')
    wishlistTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        if (trigger.matches('.acc-Navigation_Link')) {
          trigger.classList.add('acc-Navigation_LinkActive')
        }

        this.handleDrawerFocus(trigger)
      })
    })
  }

  handleDrawerFocus (trigger) {
    // Find drawer
    const wishlistDrawer = document.querySelector('#mst-iwish-drawer-root')
    if (!wishlistDrawer) return

    // Focus drawer
    trapFocus(wishlistDrawer)

    const handleDrawerClose = e => {
      // If eventTarget is a close button...
      if (!e.target.matches('[data-i-wishlist-el="close"]')) return

      disableTrapFocus(wishlistDrawer)

      // Move focus elsewhere
      trigger ? trigger.focus() : document.body.focus()

      wishlistDrawer.removeEventListener('click', handleDrawerClose)
    }

    // Await drawer close
    wishlistDrawer.addEventListener('click', handleDrawerClose)
  }

  onSwapToCart () {
    if (document.querySelector('.iwish-backdrop')) {
      document.querySelector('.iwish-backdrop').click()
    }

    if (!document.body.classList.contains('drw-Drawers-cart')) {
      document
        .querySelector('.drw-Drawers')
        .classList.add('drw-Drawers-noTransition')

      if (document.querySelector('[data-drawers-trigger="cart"]')) {
        document.querySelector('[data-drawers-trigger="cart"]').click()
      }

      window.setTimeout(() => {
        document
          .querySelector('.drw-Drawers')
          .classList.remove('drw-Drawers-noTransition')
      }, 300)
    }
  }

  updateWishlistCount () {
    if (this.externalEls?.count?.exists && typeof Storage !== 'undefined') {
      this.externalEls.count.elements.forEach(countEl => {
        const count =
          typeof localStorage.iWishCnt !== 'undefined'
            ? localStorage.iWishCnt
            : ''
        countEl.dataset.count = count
        countEl.innerHTML = count
      })
    }
  }

  onClose () {
    if (document.querySelector('.iwish-backdrop')) {
      document.querySelector('.iwish-backdrop').click()

      document.body.classList.remove('util-SiteOverflowed')
    }

    if (document.querySelector('.acc-Navigation_Link.iWishView')) {
      document
        .querySelectorAll('.acc-Navigation_Link.iWishView')
        .forEach(el => {
          el.classList.remove('acc-Navigation_LinkActive')
        })
    }
  }

  setDrawerState () {
    if (document.querySelector('.react-side-draw')) {
      const wishlistDrawer = document.querySelector('.react-side-draw')

      if (wishlistDrawer.classList.contains('open')) {
        document.body.classList.add('util-SiteOverflowed')
        this.handleDrawerFocus()
      }
    }
  }

  removeWishlist () {
    if (document.querySelector('.trash-btn')) {
      document.querySelector('.trash-btn').click()
    }
  }

  observeDrawer () {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          if (mutation.addedNodes[i].classList !== undefined) {
            if (mutation.addedNodes[i].classList.contains('iwish-backdrop')) {
              this.addHeader()
              this.addFooter()
              this.setDrawerState()

              if (document.querySelector('.iwish-backdrop')) {
                document
                  .querySelectorAll('.iwish-backdrop')
                  .forEach(backdropEl => {
                    backdropEl.addEventListener('click', () => {
                      this.onClose()
                    })
                  })
              }
            }

            if (mutation.addedNodes[i].classList.contains('iwishProduct-row')) {
              // this.updatePrices()
              this.checkForDiscountPricing()

              if (document.querySelector('.trash-btn')) {
                document
                  .querySelectorAll('.trash-btn')
                  .forEach(removeFromWishlistEl => {
                    removeFromWishlistEl.addEventListener('click', () => {
                      window.setTimeout(() => {
                        this.updateWishlistCount()
                      }, 500)
                    })
                  })
              }

              if (document.querySelector('.cart-btn')) {
                document.querySelectorAll('.cart-btn').forEach(addToCartEl => {
                  addToCartEl.addEventListener('click', () => {
                    const variantId = addToCartEl
                      .closest('.iwishProduct-row')
                      .id.replace('transfer_', '')

                    window.setTimeout(() => {
                      this.removeWishlist()
                      this.updateWishlistCount()
                      this.updatePushcart()
                      this.onSwapToCart()
                    }, 500)

                    window.setTimeout(() => {
                      if (
                        variantId &&
                        document.querySelector(
                          `[data-variant-select="${variantId}"]`,
                        )
                      ) {
                        document
                          .querySelector(`[data-variant-select="${variantId}"]`)
                          .focus()
                      }
                    }, 1000)
                  })
                })
              }
            }
          }
        }
      })
    })

    observer.observe(document.querySelector('#mst-iwish-drawer-root'), {
      childList: true,
      subtree: true,
    })
  }

  async updatePushcart () {
    const { pushCartSections } = window.BAO.sectionRenderer

    const sectionHtml = await window.BAO.sectionRenderer.fetch(
      pushCartSections.map(s => s.section),
    )

    window.BAO.sectionRenderer.renderMultiple(
      pushCartSections.map(s =>
        Object.assign({}, s, { html: sectionHtml[s.section] }),
      ),
    )
  }

  updatePrices () {
    if (document.querySelector('.react-side-draw .iwishProduct-row span.m-0')) {
      document
        .querySelectorAll('.react-side-draw .iwishProduct-row span.m-0')
        .forEach(priceEl => {
          const priceInt = Number(priceEl.textContent.replace(/[^0-9.-]+/g, ''))

          const cents = priceInt * 100

          priceEl.textContent = `${formatMoney(cents)
            .replace('.00', '')
            .replace(',', ' ')}`
        })
    }
  }

  async checkForDiscountPricing () {
    if (
      window.BAO.discount === 0 ||
      !window.BAO.discount ||
      !window.theme.wishlist.token ||
      !window.theme.customer.id
    ) { return }

    // If the customer is logged in and is eligible for a discount, we fetch
    // the currrent wishlist data.
    const wishListdata = await this.fetchWishlistData()
    if (!wishListdata.result.length > 0) return

    const wishlistDrawerItems = document.querySelectorAll(
      '.react-side-draw .iwishProduct-row',
    )

    wishlistDrawerItems.forEach(itemEl => {
      const priceEl = itemEl.querySelector('.iwish_price_wrapper')

      // The markup generated by iWish has the variant ID stored in a data attribute
      const variantId = itemEl
        .querySelector('[data-var_id]')
        ?.getAttribute('data-var_id')

      if (
        priceEl &&
        variantId &&
        !priceEl.hasAttribute('data-discount-updated')
      ) {
        // We then check to see if the fetched data includes data for this variant
        const matchingVariant = wishListdata.result.find(
          item => item.variant.id === variantId,
        )?.variant

        if (
          matchingVariant &&
          matchingVariant?.price &&
          matchingVariant?.compareAtPrice === null
        ) {
          // If we have valid variant data and it includes no compareAtPrice, then we build,
          // format, and update the markup with the discounted value.

          const priceInCents = Number(matchingVariant.price) * 100

          // Calculate the before and after pricing
          const compareAtPrice = priceInCents
          const discountFraction = window.BAO.discount / 100
          const discountPrice = priceInCents - priceInCents * discountFraction

          // Format them
          const compareAtPriceFormatted = formatMoney(compareAtPrice)
          const discountPriceFormatted = formatMoney(discountPrice)

          // Retrieve the new markup, passing in the formatted values
          priceEl.innerHTML = this.buildDisountPricingElement(
            compareAtPriceFormatted,
            discountPriceFormatted,
          )
          priceEl.setAttribute('data-discount-updated', true)
        }
      }
    })
  }

  buildDisountPricingElement (compareAtPrice, discountPrice) {
    return `
      <span aria-label="product price" class="mst-iwish-comparePrice">
        ${compareAtPrice}
      </span>
      <span aria-label="product price" class="mst-iwish-price m-0 ">
        ${discountPrice}
      </span>
    `
  }

  addHeader () {
    if (this?.els?.header?.exists) {
      const container = document.querySelector('.react-side-draw')
      container.insertBefore(this.els.header.element, container.firstChild)
    }
  }

  addFooter () {
    if (this?.els?.footer?.exists) {
      const container = document.querySelector('.react-side-draw')
      container.appendChild(this.els.footer.element)
    }
  }

  async fetchWishlistData () {
    // Docs: https://shopapps.in/api-docs/wishlist/V1/#/operations/getIwishdata_wishlist_V1_fetchWishlistData__customer_id__post
    const url = `https://api.myshopapps.com/wishlist/V1/fetchWishlistData/${window.theme.customer.id}`
    const options = {
      method: 'POST',
      headers: {
        xtoken: window.theme.wishlist.token,
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: new URLSearchParams({ category_id: '' }),
    }

    try {
      const response = await fetch(url, options)
      const data = await response.json()
      return data
    } catch (error) {
      console.error(error)
    }
  }
}

if (!customElements.get('i-wishlist')) {
  customElements.define('i-wishlist', IWishlist)
}
